import { QuestionEditor } from './question_editor';

export function initQuestionEditor(questionWrap) {
  const editor = new QuestionEditor(questionWrap);
  editor.init();
}
